"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var DANGER_COLOR = 'axsui.status.danger.default';
var Div = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
});
var Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  margin-bottom: 4px;\n  flex-grow: 1;\n"], ["\n  color: ",
    ";\n  font-size: 13px;\n  margin-bottom: 4px;\n  flex-grow: 1;\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme, labelColor = _a.labelColor, labelColorDisabled = _a.labelColorDisabled;
    return disabled
        ? utils_1.parseThemePath(labelColorDisabled, theme, colors_1.colors.GREY_300)
        : utils_1.parseThemePath(labelColor, theme, colors_1.colors.GREY_650);
});
var Extra = styled_components_1.default(AXSFlexItem_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  font-style: italic;\n  margin-bottom: 4px;\n  text-align: right;\n"], ["\n  color: ",
    ";\n  font-size: 13px;\n  font-style: italic;\n  margin-bottom: 4px;\n  text-align: right;\n"])), function (_a) {
    var error = _a.error, disabled = _a.disabled, theme = _a.theme;
    return !error
        ? disabled
            ? colors_1.colors.GREY_300
            : colors_1.colors.GREY_450
        : utils_1.parseThemePath(DANGER_COLOR, theme, colors_1.colors.RED_300);
});
var FieldHeader = styled_components_1.default(AXSFlex_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width ? width : '100%';
});
var Caption = styled_components_1.default(AXSFlexItem_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  font-style: italic;\n  line-height: 28px;\n  margin-top: -10px;\n"], ["\n  color: ",
    ";\n  font-size: 13px;\n  font-style: italic;\n  line-height: 28px;\n  margin-top: -10px;\n"])), function (_a) {
    var disabled = _a.disabled, error = _a.error, theme = _a.theme;
    return error
        ? utils_1.parseThemePath(DANGER_COLOR, theme, colors_1.colors.RED_300)
        : (disabled ? colors_1.colors.GREY_300 : colors_1.colors.GREY_450);
});
var FieldContainer = styled_components_1.default(AXSFlexItem_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-bottom: 2px;\n  width: 100%;\n"], ["\n  margin-bottom: 2px;\n  width: 100%;\n"])));
var AXSFormField = function (_a) {
    var label = _a.label, labelColor = _a.labelColor, labelColorDisabled = _a.labelColorDisabled, children = _a.children, className = _a.className, caption = _a.caption, captionColor = _a.captionColor, error = _a.error, disabled = _a.disabled, theme = _a.theme, labelWidth = _a.labelWidth, width = _a.width, extra = _a.extra, extraColor = _a.extraColor, id = _a.id, readOnly = _a.readOnly, props = __rest(_a, ["label", "labelColor", "labelColorDisabled", "children", "className", "caption", "captionColor", "error", "disabled", "theme", "labelWidth", "width", "extra", "extraColor", "id", "readOnly"]);
    return (React.createElement(Div, __assign({ flexWrap: "wrap" }, props, { className: classnames_1.default(['c-axs-form-field', className]) }),
        React.createElement(FieldHeader, { width: width },
            React.createElement(Label, { htmlFor: id, width: labelWidth, error: error, disabled: disabled, theme: theme, labelColor: labelColor, labelColorDisabled: labelColorDisabled, className: "c-axs-form-field__label" }, label),
            extra && (React.createElement(Extra, { width: labelWidth, disabled: disabled, extraColor: extraColor, theme: theme, className: "c-axs-form-field__extra" }, extra))),
        React.createElement(FieldContainer, { error: error },
            React.createElement(React.Fragment, null,
                ' ',
                React.Children.map(children, function (child) {
                    return React.cloneElement(child, {
                        disabled: disabled,
                        error: error,
                        id: id,
                        readOnly: readOnly,
                        width: width,
                    });
                }))),
        (caption && (React.createElement(Caption, { className: "c-axs-form-field__caption", captionColor: captionColor, error: error, disabled: disabled },
            caption,
            ' ')))));
};
AXSFormField.defaultProps = {
    captionColor: 'axsui.forms.captionColor',
    extraColor: 'axsui.forms.extraColor',
    labelColor: 'axsui.forms.labelColor',
    labelColorDisabled: 'axsui.forms.labelColor',
    required: false,
};
exports.default = AXSFormField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map